<template>
  <div class="u-row u-row--sm u-marg-t-xl">
    <anim-scroll :isStagger="true" class="u-marg-l-1of12 u-w6of12">
      <div class="themes__box">
        <div
          class="themes__item"
          :class="['themes__item--'+i, {'is-active': i === currentIndex}]"
          v-for="i in 7"
          :key="i"
          @mouseover="onMouseOver(i)"
          @mouseleave="onMouseLeave"
        >
          <anim-scroll :isStagger="true" class="u-box-1by1">
            <div class="u-wrapper-panel">
              <img class="u-fit-cover themes__item__image" :src="`/images/theme-${i}.jpg`">
            </div>
          </anim-scroll>
        </div>
      </div>
    </anim-scroll>
    <anim-scroll :isStagger="true" class="u-w4of12 u-relative">
      <transition name="t-fader">
        <div class="themes__content u-wrapper-panel u-row u-middle u-pad-l-lg" :key="i" v-if="i === currentIndex" v-for="i in 7">
          <div>
            <h2 class="t-h1 t-light">{{ $t('themes.title' + i) }}</h2>
            <div class="t-text--big">{{ $t('themes.content' + i) }}</div>
          </div>
        </div>
      </transition>
    </anim-scroll>
  </div>
</template>

<script>
import AnimScroll from '@/components/common/AnimScroll'

export default {
  components: {
    AnimScroll
  },
  data () {
    return {
      currentIndex: 1
    }
  },
  mounted () {
    this.timeout = setTimeout(this.autoPlay, 3000)
  },
  methods: {
    onMouseLeave () {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(this.autoPlay, 3000)
    },
    onMouseOver (index) {
      clearTimeout(this.timeout)
      this.currentIndex = index
    },
    autoPlay () {
      if (this.currentIndex < 7) {
        this.currentIndex++
      }
      else {
        this.currentIndex = 1
      }

      this.timeout = setTimeout(this.autoPlay, 3000)
    }
  }
}
</script>

<style lang="stylus" scroped>
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

.themes
  &__box
    position relative

    &:before
      content ''
      width 100%
      display block
      position relative
      padding-top 87%
  
  &__item
    position absolute
    border-radius 50%
    overflow hidden
    
    &:after
      content ''
      position absolute
      top 0
      left 0
      height 100%
      width 100%
      border-radius 50%
      border solid 2px $colors.white
      opacity 0
      transition opacity .3s linear
    
    &.is-active:after
      opacity 1

    &__image
      transform scale(1) translateZ(0)
      transition transform 1s ease-in-out-quad
    
    &:hover &__image
      transform scale(1.2) translateZ(0)
  
    &--1
      top 0
      left 20%
      width 20%
    &--2
      top 4.5%
      left 71%
      width 21%
    &--3
      top 26%
      left 0
      width 19%
    &--4
      top 23%
      left 39%
      width 26%
    &--5
      top 38%
      left 80%
      width 21%
    &--6
      top 58%
      left 18%
      width 26%
    &--7
      top 62%
      left 57%
      width 19%
</style>